var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "blocks" }, [
        _c("div", { staticClass: "mobile-list" }, [
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-between mx-3 px-1"
            },
            [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c("span", {
                  staticClass: "mod-icon-arrow-left mod-icon-back",
                  on: {
                    click: function($event) {
                      _vm.$router.back()
                    }
                  }
                }),
                _vm._v(" "),
                _c("h2", { staticClass: "ml-2" }, [_vm._v("Totals")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex-grow-1 mr-3" }, [
                _c("div", { staticClass: "input-group search w-100 ml-3" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn input-group-btn",
                      attrs: { type: "button" },
                      on: { click: _vm.clearSearch }
                    },
                    [
                      _c("i", {
                        class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.q,
                        expression: "q"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Search" },
                    domProps: { value: _vm.q },
                    on: {
                      keyup: function($event) {
                        _vm.searchText($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.q = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mt-3 border-bottom" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center justify-content-between mx-3 px-1"
              },
              [
                _c("p", { staticClass: "text-secondary m-0" }, [
                  _vm._v("Statistics for " + _vm._s(_vm.meta.total) + " jobs")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex align-items-center mb-1" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-schedule btn-refine",
                      on: {
                        click: function($event) {
                          _vm.showFilters = true
                        }
                      }
                    },
                    [
                      !_vm.clearFiltersButtonShouldBeDisabled
                        ? _c("span", {
                            staticClass: "mobile-dot-refine-active-filters"
                          })
                        : _vm._e(),
                      _vm._v("\n              REFINE\n            ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-refine btn-schedule ml-2",
                      class: [
                        _vm.filters.deductedMoverWages
                          ? "btn-primary"
                          : "btn-secondary"
                      ],
                      on: {
                        click: function($event) {
                          _vm.setDeductedMoverWagesFilter(
                            _vm.filters.deductedMoverWages === 1 ? 0 : 1
                          )
                        }
                      }
                    },
                    [_vm._v("\n              $$\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary ml-3",
                      on: { click: _vm.downloadReport }
                    },
                    [_vm._v("\n              Download report\n            ")]
                  ),
                  _vm._v(" "),
                  _vm.$_can("clusters.totals.mark-as-paid")
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary ml-3",
                          on: { click: _vm.markAsPaid }
                        },
                        [_vm._v("\n              Mark as paid\n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary expand-all",
                      on: {
                        click: function($event) {
                          _vm.expanded = !_vm.expanded
                        }
                      }
                    },
                    [
                      _c("i", {
                        class: [
                          _vm.expanded ? "fa fa-compress" : "fa fa-expand"
                        ]
                      })
                    ]
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-items-center mt-4 pt-1 px-4" },
            [
              _c(
                "a",
                {
                  staticClass: "mobile-menu-link",
                  class: [
                    _vm.mobileMenuState === "stats"
                      ? "mobile-menu-link-active"
                      : ""
                  ],
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.mobileMenuState = "stats"
                    }
                  }
                },
                [_vm._v("Stats")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "mobile-menu-link",
                  class: [
                    _vm.mobileMenuState === "listOfJobs"
                      ? "mobile-menu-link-active"
                      : ""
                  ],
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.mobileMenuState = "listOfJobs"
                    }
                  }
                },
                [_vm._v("List of jobs")]
              )
            ]
          ),
          _vm._v(" "),
          _vm.mobileMenuState === "listOfJobs"
            ? _c(
                "div",
                { staticClass: "list-jobs container-fluid m-0 mt-3" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._l(_vm.totals, function(total) {
                    return _c("TotalsBlockMobile", {
                      key: total.id,
                      attrs: { total: total, expanded: _vm.expanded },
                      on: {
                        openSidebar: function($event) {
                          _vm.openSidebar(total)
                        }
                      }
                    })
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row blocks" },
                    [
                      _c("pagination", {
                        staticClass: "col-sm-6 mb-1 pr-0",
                        attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mobileMenuState === "stats"
            ? _c(
                "div",
                { staticClass: "container-fluid m-0 mt-3" },
                [
                  _c("TotalsStatisticMobile", {
                    attrs: { sums: _vm.sums, averages: _vm.averages }
                  })
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "desktop-list" },
          [
            _c(
              "div",
              { staticClass: "row pt-3 l-m-b-20 d-flex align-items-center" },
              [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "col-7 d-flex" }, [
                  _c("div", { staticClass: "input-group search" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn input-group-btn",
                        attrs: { type: "button" },
                        on: { click: _vm.clearSearch }
                      },
                      [
                        _c("i", {
                          class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.q,
                          expression: "q"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Search" },
                      domProps: { value: _vm.q },
                      on: {
                        keyup: function($event) {
                          _vm.searchText($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.q = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary ml-3",
                      on: { click: _vm.downloadReport }
                    },
                    [_vm._v("\n            Download report\n          ")]
                  ),
                  _vm._v(" "),
                  _vm.$_can("clusters.totals.mark-as-paid")
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary ml-3",
                          on: { click: _vm.markAsPaid }
                        },
                        [_vm._v("\n            Mark as paid\n          ")]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-4 d-flex align-items-center justify-content-end"
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("load-filter-dropdown", {
                            attrs: { route: _vm.$route.name },
                            on: {
                              filterSelected: _vm.loadFilters,
                              filterTemplatesInitialized:
                                _vm.setFilterTemplatesInitialized
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-refine btn-schedule",
                            class: [
                              _vm.filters.deductedMoverWages
                                ? "btn-primary"
                                : "btn-secondary"
                            ],
                            on: {
                              click: function($event) {
                                _vm.setDeductedMoverWagesFilter(
                                  _vm.filters.deductedMoverWages === 1 ? 0 : 1
                                )
                              }
                            }
                          },
                          [
                            _vm.filters.deductedMoverWages
                              ? [
                                  _vm._v(
                                    "\n                  Show profit with wages\n                "
                                  )
                                ]
                              : [
                                  _vm._v(
                                    "\n                  Show profit without wages\n                "
                                  )
                                ]
                          ],
                          2
                        )
                      ])
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-2" }, [
              _c("div", { staticClass: "col-11 filters-field" }, [
                _c("span", [_vm._v("Filters:")]),
                _vm._v(" "),
                _vm.filtersLoaded
                  ? _c(
                      "span",
                      [
                        _vm.carriers && _vm.filters.carrier.length
                          ? _c(
                              "span",
                              [
                                _vm._l(_vm.filters.carrier, function(carrier) {
                                  return [
                                    _vm.carriers.find(function(el) {
                                      return el.id === carrier
                                    })
                                      ? _c(
                                          "span",
                                          {
                                            key: carrier,
                                            staticClass:
                                              "filter-item btn btn-filter"
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "mod-icon-filter",
                                              on: {
                                                click: function($event) {
                                                  _vm.removeFilter(
                                                    "carrier",
                                                    carrier
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(
                                              "\n                  Carrier: " +
                                                _vm._s(
                                                  _vm.carriers.find(function(
                                                    el
                                                  ) {
                                                    return el.id === carrier
                                                  }).name
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.companies && _vm.filters.company.length
                          ? _c(
                              "span",
                              [
                                _vm._l(_vm.filters.company, function(company) {
                                  return [
                                    _vm.companies.find(function(el) {
                                      return el.id === company
                                    })
                                      ? _c(
                                          "span",
                                          {
                                            key: company,
                                            staticClass:
                                              "filter-item btn btn-filter"
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "mod-icon-filter",
                                              on: {
                                                click: function($event) {
                                                  _vm.removeFilter(
                                                    "company",
                                                    company
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(
                                              "\n                  Company: " +
                                                _vm._s(
                                                  _vm.companies.find(function(
                                                    el
                                                  ) {
                                                    return el.id === company
                                                  }).name
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.filters.move_date
                          ? _c(
                              "span",
                              { staticClass: "filter-item btn btn-filter" },
                              [
                                _c("span", {
                                  staticClass: "mod-icon-filter",
                                  on: {
                                    click: function($event) {
                                      _vm.removeFilter("move_date")
                                    }
                                  }
                                }),
                                _vm._v(
                                  "\n              Move Date: " +
                                    _vm._s(_vm.filters.move_date)
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.filters.created_at
                          ? _c(
                              "span",
                              { staticClass: "filter-item btn btn-filter" },
                              [
                                _c("span", {
                                  staticClass: "mod-icon-filter",
                                  on: {
                                    click: function($event) {
                                      _vm.removeFilter("created_at")
                                    }
                                  }
                                }),
                                _vm._v(
                                  "\n              Booked Date: " +
                                    _vm._s(_vm.filters.created_at)
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.salesFilter &&
                        _vm.filters.clusterUser &&
                        _vm.filters.clusterUser.length
                          ? _c(
                              "span",
                              [
                                _vm._l(_vm.filters.clusterUser, function(
                                  clusterUser
                                ) {
                                  return [
                                    _vm.salesFilter.find(function(el) {
                                      return el.id === clusterUser
                                    })
                                      ? _c(
                                          "span",
                                          {
                                            key: clusterUser,
                                            staticClass:
                                              "filter-item btn btn-filter"
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "mod-icon-filter",
                                              on: {
                                                click: function($event) {
                                                  _vm.removeFilter(
                                                    "clusterUser",
                                                    clusterUser
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(
                                              "\n                  Sales: " +
                                                _vm._s(
                                                  _vm.salesFilter.find(function(
                                                    el
                                                  ) {
                                                    return el.id === clusterUser
                                                  }).full_name
                                                )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.salesFilter &&
                        _vm.filters.bookedByUser &&
                        _vm.filters.bookedByUser.length
                          ? _c(
                              "span",
                              [
                                _vm._l(_vm.filters.bookedByUser, function(
                                  bookedByUser
                                ) {
                                  return [
                                    _vm.salesFilter.find(function(el) {
                                      return el.id === bookedByUser
                                    })
                                      ? _c(
                                          "span",
                                          {
                                            key: bookedByUser,
                                            staticClass:
                                              "filter-item btn btn-filter"
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "mod-icon-filter",
                                              on: {
                                                click: function($event) {
                                                  _vm.removeFilter(
                                                    "bookedByUser",
                                                    bookedByUser
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(
                                              "\n                  Booked by: " +
                                                _vm._s(
                                                  _vm.salesFilter.find(function(
                                                    el
                                                  ) {
                                                    return (
                                                      el.id === bookedByUser
                                                    )
                                                  }).full_name
                                                )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.filters.userCompanies &&
                        _vm.clusterUsersFilter.length
                          ? [
                              _vm.clusterUsersFilter.find(function(el) {
                                return el.id === _vm.filters.userCompanies
                              })
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "filter-item btn btn-filter"
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "mod-icon-filter",
                                        on: {
                                          click: function($event) {
                                            _vm.removeFilter("userCompanies")
                                          }
                                        }
                                      }),
                                      _vm._v(
                                        "\n                User companies: " +
                                          _vm._s(
                                            _vm.clusterUsersFilter.find(
                                              function(el) {
                                                return (
                                                  el.id ===
                                                  _vm.filters.userCompanies
                                                )
                                              }
                                            ).full_name
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.tags && _vm.filters.tags && _vm.filters.tags.length
                          ? _c(
                              "span",
                              _vm._l(_vm.filters.tags, function(tag) {
                                return _c(
                                  "span",
                                  {
                                    key: tag,
                                    staticClass: "filter-item btn btn-filter"
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "mod-icon-filter",
                                      on: {
                                        click: function($event) {
                                          _vm.removeFilter("tags", tag)
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                Tag: " +
                                        _vm._s(
                                          _vm.tags.find(function(el) {
                                            return el.id === tag
                                          }).name
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              })
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.moverNumbers &&
                        _vm.filters.movers &&
                        _vm.filters.movers.length
                          ? _c(
                              "span",
                              _vm._l(_vm.filters.movers, function(mover) {
                                return _c(
                                  "span",
                                  {
                                    key: mover,
                                    staticClass: "filter-item btn btn-filter"
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "mod-icon-filter",
                                      on: {
                                        click: function($event) {
                                          _vm.removeFilter("movers", mover)
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                Number of movers: " +
                                        _vm._s(mover) +
                                        " "
                                    )
                                  ]
                                )
                              })
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.filters.moveSizes && _vm.filters.moveSizes.length
                          ? _c(
                              "span",
                              _vm._l(_vm.filters.moveSizes, function(moveSize) {
                                return _c(
                                  "span",
                                  {
                                    key: moveSize,
                                    staticClass: "filter-item btn btn-filter"
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "mod-icon-filter",
                                      on: {
                                        click: function($event) {
                                          _vm.removeFilter(
                                            "moveSizes",
                                            moveSize
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                Move size: " +
                                        _vm._s(
                                          _vm.moveSizes.find(function(el) {
                                            return el.id === moveSize
                                          }).name
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              })
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.filters.deductedMoverWages
                  ? _c("span", { staticClass: "filter-item btn btn-filter" }, [
                      _c("span", {
                        staticClass: "mod-icon-filter",
                        on: {
                          click: function($event) {
                            _vm.filters.deductedMoverWages = null
                          }
                        }
                      }),
                      _vm._v("\n            Deducted mover wages\n          ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary add-filters",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.showFilters = true
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-plus filter-icon" })]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-1 d-flex justify-content-end" }, [
                _c("div", { staticClass: "dropdown" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-secondary sort-button sort-button-selected",
                      attrs: {
                        id: "dropdownMenuButton",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false"
                      }
                    },
                    [
                      _vm.selectedKey.length
                        ? _c("i", {
                            staticClass: "fa pr-2",
                            class: [
                              _vm.ascOrDesc === "asc"
                                ? "fa-sort-amount-asc"
                                : "fa-sort-amount-desc"
                            ]
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedKey === "created_at"
                        ? _c("span", [
                            _vm._v(
                              "\n                Created at\n              "
                            )
                          ])
                        : _vm.selectedKey === "move_date"
                          ? _c("span", [
                              _vm._v(
                                "\n                Move date\n              "
                              )
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n                Sort by\n              "
                              )
                            ]),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-caret-down caret" })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "dropdown-menu sort-dropdown dropdown-menu-right",
                      attrs: { "aria-labelledby": "dropdownMenuButton" }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "dropdown-item sort-dropdown-item nav-link btn",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.sortBy("created_at")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              class: [
                                _vm.selectedKey === "created_at"
                                  ? "selected"
                                  : ""
                              ]
                            },
                            [
                              _vm._v(
                                "\n                  Created date\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm.selectedKey === "created_at"
                              ? _c("i", {
                                  staticClass: "fa",
                                  class: [
                                    _vm.ascOrDesc === "asc"
                                      ? "fa-sort-amount-asc"
                                      : "fa-sort-amount-desc"
                                  ]
                                })
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "dropdown-item sort-dropdown-item nav-link btn",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.sortBy("move_date")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              class: [
                                _vm.selectedKey === "move_date"
                                  ? "selected"
                                  : ""
                              ]
                            },
                            [
                              _vm._v(
                                "\n                  Move date\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm.selectedKey === "move_date"
                              ? _c("i", {
                                  staticClass: "fa",
                                  class: [
                                    _vm.ascOrDesc === "asc"
                                      ? "fa-sort-amount-asc"
                                      : "fa-sort-amount-desc"
                                  ]
                                })
                              : _vm._e()
                          ])
                        ]
                      )
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.loading
              ? [
                  _c(
                    "vue-content-loading",
                    { attrs: { width: 800, height: 450 } },
                    _vm._l(15, function(x) {
                      return _c("rect", {
                        key: x,
                        attrs: {
                          x: "10",
                          y: 15 * x * 1.4,
                          rx: "5",
                          ry: "5",
                          width: "720",
                          height: "6"
                        }
                      })
                    })
                  )
                ]
              : !_vm.totals.length
                ? [_c("span", [_vm._v("There are no results.")])]
                : [
                    _c(
                      "div",
                      { staticClass: "totals-table" },
                      [
                        _c("TotalsStatistics", {
                          staticClass: "blocks",
                          attrs: {
                            meta: _vm.meta,
                            sums: _vm.sums,
                            averages: _vm.averages
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "totals-wrapper blocks" },
                          _vm._l(_vm.totals, function(total) {
                            return _c("TotalsBlock", {
                              key: total.job_id,
                              staticClass: "pointer",
                              attrs: { total: total },
                              on: {
                                openSidebar: function($event) {
                                  _vm.openSidebar(total)
                                }
                              }
                            })
                          })
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row blocks" },
                      [
                        _vm.meta.total
                          ? _c(
                              "div",
                              {
                                staticClass: "col-sm-6 mb-1 text-black-50 pl-0"
                              },
                              [
                                _vm._v(
                                  "\n            Showing " +
                                    _vm._s(_vm.meta.from) +
                                    " - " +
                                    _vm._s(_vm.meta.to) +
                                    " of " +
                                    _vm._s(_vm.meta.total) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("pagination", {
                          staticClass: "col-sm-6 mb-1 pr-0",
                          attrs: {
                            "change-page": _vm.changePage,
                            meta: _vm.meta
                          }
                        })
                      ],
                      1
                    )
                  ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _vm.showFilters
                  ? _c(
                      "div",
                      { staticClass: "filters-side-modal flex flex-column" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function($event) {
                                _vm.showFilters = !_vm.showFilters
                              }
                            }
                          },
                          [
                            _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                              _c("span", { staticClass: "btn btn-back" }),
                              _vm._v("Add Filter")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              "\n            Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "l-bg-white" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("div", { staticClass: "row filters" }, [
                                _vm.companies
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Company")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.companies,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "hide-selected": true,
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.company,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "company",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.company"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.carriers
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Carriers")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.carriers,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "hide-selected": true,
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.carrier,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "carrier",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.carrier"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.moveSizes
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Move sizes")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.moveSizes,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "hide-selected": true,
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.moveSizes,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "moveSizes",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.moveSizes"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.moverNumbers
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [
                                            _vm._v("Number of movers")
                                          ]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.moverNumbers,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "hide-selected": true,
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.movers,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "movers",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.movers"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Sales Rep.")]),
                                      _vm._v(" "),
                                      _c("key-multiselect", {
                                        attrs: {
                                          options: _vm.salesFilter,
                                          multiple: true,
                                          "clear-on-select": false,
                                          "custom-label": _vm.customLabel,
                                          "hide-selected": true,
                                          "preserve-search": false,
                                          label: "name",
                                          "track-by": "id"
                                        },
                                        on: { input: _vm.search },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tag",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "multiselect__tag"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option.full_name
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "multiselect__tag-icon",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          props.remove(
                                                            props.option
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.filters.clusterUser,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "clusterUser",
                                              $$v
                                            )
                                          },
                                          expression: "filters.clusterUser"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Booked by")]),
                                      _vm._v(" "),
                                      _c("key-multiselect", {
                                        attrs: {
                                          options: _vm.salesFilter,
                                          multiple: true,
                                          "clear-on-select": false,
                                          "custom-label": _vm.customLabel,
                                          "hide-selected": true,
                                          "preserve-search": false,
                                          label: "name",
                                          "track-by": "id"
                                        },
                                        on: { input: _vm.search },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tag",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "multiselect__tag"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option.full_name
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "multiselect__tag-icon",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          props.remove(
                                                            props.option
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.filters.bookedByUser,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "bookedByUser",
                                              $$v
                                            )
                                          },
                                          expression: "filters.bookedByUser"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.clusterUsersFilter &&
                                _vm.clusterUsersFilter.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [
                                            _vm._v("User companies")
                                          ]),
                                          _vm._v(" "),
                                          _c("simple-select", {
                                            attrs: {
                                              options: _vm.clusterUsersFilter,
                                              "input-id":
                                                "user-companies-select",
                                              placeholder: "Select User",
                                              "track-by": "id",
                                              label: "full_name"
                                            },
                                            on: { input: _vm.search },
                                            model: {
                                              value: _vm.filters.userCompanies,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "userCompanies",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filters.userCompanies"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Move date")]),
                                      _vm._v(" "),
                                      _c("flat-pickr", {
                                        staticClass: "simple-select-input",
                                        attrs: {
                                          config: _vm.config,
                                          placeholder: "Select Move Date",
                                          name: "date"
                                        },
                                        on: {
                                          "on-close": _vm.onMoveDateChange
                                        },
                                        model: {
                                          value: _vm.filters.move_date,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "move_date",
                                              $$v
                                            )
                                          },
                                          expression: "filters.move_date"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.filters.move_date
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date",
                                              on: {
                                                click:
                                                  _vm.clearMoveDateAndSearch
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "mod-icon-clear"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "sr-only",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                },
                                                [_vm._v("Clear")]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date clear-date-transparent"
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "mod-icon-rates-dark"
                                              })
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Booked date")]),
                                      _vm._v(" "),
                                      _c("flat-pickr", {
                                        staticClass: "simple-select-input",
                                        attrs: {
                                          config: _vm.config,
                                          placeholder: "Select Booked Date",
                                          name: "date"
                                        },
                                        on: {
                                          "on-close": _vm.onCreatedAtChange
                                        },
                                        model: {
                                          value: _vm.filters.created_at,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "created_at",
                                              $$v
                                            )
                                          },
                                          expression: "filters.created_at"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.filters.created_at
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date",
                                              on: {
                                                click:
                                                  _vm.clearCreatedAtAndSearch
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "mod-icon-clear"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "sr-only",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                },
                                                [_vm._v("Clear")]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date clear-date-transparent"
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "mod-icon-rates-dark"
                                              })
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.$_can("tags.show")
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Tags")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            staticClass: "w-100",
                                            attrs: {
                                              options: _vm.tags,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "close-on-select": false,
                                              "track-by": "id",
                                              label: "name"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag p-0 bg-transparent"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          [
                                                            _c("tag-color", {
                                                              attrs: {
                                                                color:
                                                                  props.option
                                                                    .color.name,
                                                                name:
                                                                  props.option
                                                                    .name
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              },
                                              {
                                                key: "option",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "option__desc"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex align-items-center justify-content-between"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "option__title"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      props
                                                                        .option
                                                                        .name
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.tags,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "tags",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.tags"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-auto" }, [
                          _c("div", { staticClass: "col" }, [
                            !_vm.clearFiltersButtonShouldBeDisabled
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-not-active text-dark w-100",
                                    attrs: { type: "button" },
                                    on: { click: _vm.clearFilters }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Clear filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col" }, [
                            !_vm.clearFiltersButtonShouldBeDisabled
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary text-white w-100",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.saveFiltersModal = true
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Save filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.openTotalsSidebar
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask-alt",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    return _vm.closeSidebar($event)
                  }
                }
              },
              [
                _vm.openTotalsSidebar
                  ? _c(
                      "div",
                      { staticClass: "totals-side-modal" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "heading pointer",
                            on: { click: _vm.closeSidebar }
                          },
                          [
                            _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                              _c("span", { staticClass: "btn btn-back" }),
                              _vm._v(_vm._s(_vm.selectedTotal.ref_id))
                            ]),
                            _vm._v(" "),
                            _vm.selectedTotal.payment_status_id === 3
                              ? _c(
                                  "span",
                                  { staticClass: "ml-2 total-status-paid" },
                                  [_vm._v("\n            paid\n          ")]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "section-name" }, [
                          _c("h2", { staticClass: "totals-side-modal-h2" }, [
                            _vm._v(_vm._s(_vm.selectedTotal.carrier.name))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "job-info d-flex pb-2" }, [
                          _c(
                            "div",
                            { staticClass: "col d-flex job-info-left" },
                            [
                              _c("div", { staticClass: "rate pr-3" }, [
                                _vm._v(
                                  "\n              $" +
                                    _vm._s(_vm.selectedTotal.rate) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "pr-3" }, [
                                _c("i", {
                                  staticClass: "fa fa-user totals-icon"
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "mover-number" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.selectedTotal.movers) +
                                      "\n              "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("i", {
                                  staticClass: "fa fa-truck totals-icon"
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "truck-number" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.selectedTotal.trucks) +
                                      "\n              "
                                  )
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col d-flex flex-column justify-content-end align-items-end job-info-right"
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "\n              Min hours: " +
                                    _vm._s(_vm.selectedTotal.minimum_hours) +
                                    "h\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "d-flex" }, [
                                _vm._v(
                                  "\n              Transaction fee: " +
                                    _vm._s(_vm.selectedTotal.charge_fee) +
                                    "%\n            "
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "section-name" }, [
                          _c("h2", { staticClass: "totals-side-modal-h2" }, [
                            _vm._v("job details")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "section-heading" }, [
                          _c("span", [_vm._v("Total Job Time")]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.selectedTotal.time))])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "section-content d-flex pb-2" },
                          [
                            _c("span", [
                              _vm._v("\n            Total duration\n          ")
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.selectedTotal.total_duration) +
                                  "\n          "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "section-content d-flex pb-2" },
                          [
                            _c("span", [
                              _vm._v("\n            Total breaks\n          ")
                            ]),
                            _vm._v(" "),
                            _vm.selectedTotal.breaks &&
                            _vm.selectedTotal.breaks.length
                              ? _c("div", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.formatBreaks(
                                          _vm.selectedTotal.breaks
                                        )
                                      ) +
                                      "\n          "
                                  )
                                ])
                              : _c("div", [
                                  _vm._v("\n            -\n          ")
                                ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "section-heading" }, [
                          _c("span", [_vm._v("Price Breakdown")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "section-content d-flex pb-2" },
                          [
                            _c("span", [
                              _vm._v("\n            Base price\n          ")
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n            $ " +
                                  _vm._s(_vm.selectedTotal.base_price) +
                                  "\n          "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "section-content d-flex pb-2" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "pointer",
                                on: {
                                  click: function($event) {
                                    _vm.additionalExpensesToggle = !_vm.additionalExpensesToggle
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa text-secondary",
                                  class: _vm.additionalExpensesToggle
                                    ? "fa fa-caret-down"
                                    : "fa fa-caret-right",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    "\n              Additional expenses\n            "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.loadingExpenses
                              ? _c("div", [
                                  _c("strong", [
                                    _vm._v(
                                      "$ " +
                                        _vm._s(
                                          _vm.additionalExpensesSum
                                            ? _vm.additionalExpensesSum
                                            : "0"
                                        )
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.additionalExpensesToggle && !_vm.loadingExpenses
                          ? [
                              _vm.expenses
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "section-content flex-column"
                                    },
                                    _vm._l(_vm.expenses, function(expense) {
                                      return _c(
                                        "div",
                                        {
                                          key: expense.id,
                                          staticClass: "section-child pb-2"
                                        },
                                        [
                                          _c("div", [
                                            _c("h5", [
                                              _vm._v(
                                                _vm._s(expense && expense.name)
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              "\n                $ " +
                                                _vm._s(expense.amount) +
                                                "\n              "
                                            )
                                          ])
                                        ]
                                      )
                                    })
                                  )
                                : _vm._e()
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "section-content d-flex pb-2" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "pointer",
                                on: {
                                  click: function($event) {
                                    _vm.additionalDiscountsToggle = !_vm.additionalDiscountsToggle
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa text-secondary",
                                  class: _vm.additionalDiscountsToggle
                                    ? "fa fa-caret-down"
                                    : "fa fa-caret-right",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    "\n              Discounts\n            "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.loadingDiscounts
                              ? _c("div", [
                                  _c("strong", [
                                    _vm._v(
                                      "- $ " +
                                        _vm._s(
                                          _vm.selectedTotal.total_discounts
                                        )
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.additionalDiscountsToggle && !_vm.loadingDiscounts
                          ? [
                              _vm.discounts
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "section-content flex-column"
                                    },
                                    _vm._l(_vm.discounts, function(discount) {
                                      return _c(
                                        "div",
                                        {
                                          key: discount.id,
                                          staticClass: "section-child pb-2"
                                        },
                                        [
                                          _c("div", [
                                            _c("h5", [
                                              _vm._v(
                                                _vm._s(
                                                  discount && discount.name
                                                ) +
                                                  " (" +
                                                  _vm._s(discount.type.name) +
                                                  ")"
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            [
                                              discount.discount_unit_type_id ===
                                              1
                                                ? [
                                                    _vm._v(
                                                      "\n                  - $ " +
                                                        _vm._s(
                                                          discount.amount
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]
                                                : discount.discount_unit_type_id ===
                                                  2
                                                  ? [
                                                      _vm._v(
                                                        "\n                  - $ " +
                                                          _vm._s(
                                                            discount.calculated_amount
                                                          ) +
                                                          " (" +
                                                          _vm._s(
                                                            discount.amount
                                                          ) +
                                                          "%)\n                "
                                                      )
                                                    ]
                                                  : _vm._e()
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    })
                                  )
                                : _vm._e()
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "section-heading" }, [
                          _c("span", [_vm._v("Transactions")])
                        ]),
                        _vm._v(" "),
                        _vm.selectedTotal.charges &&
                        _vm.selectedTotal.charges.length
                          ? _vm._l(
                              _vm.selectedTotal.charges.filter(function(el) {
                                return el.payment_type_id === 3
                              }),
                              function(transaction, index) {
                                return _c("div", { key: transaction.id }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "section-content d-flex pb-2"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "payment-type" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                transaction.payment_type.name
                                              ) +
                                              "\n                "
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "btn btn-link p-0 tippy-popup m-0",
                                              on: {
                                                mouseover: function($event) {
                                                  _vm.$set(
                                                    _vm.showTooltipTransactions,
                                                    index,
                                                    true
                                                  )
                                                },
                                                mouseout: function($event) {
                                                  _vm.$set(
                                                    _vm.showTooltipTransactions,
                                                    index,
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-info-circle"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.showTooltipTransactions[index]
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "popover popover-transaction tippy-info-popover"
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(transaction.date)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          transaction
                                                            .payment_method.name
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(transaction.note)
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "\n                $ " +
                                            _vm._s(transaction.amount) +
                                            "\n              "
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              }
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "section-content d-flex pb-2" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "pointer",
                                on: {
                                  click: function($event) {
                                    _vm.togglePayments = !_vm.togglePayments
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa text-secondary",
                                  class: _vm.togglePayments
                                    ? "fa fa-caret-down"
                                    : "fa fa-caret-right",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    "\n              Payments\n            "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _c("strong", [
                                _vm._v(
                                  "$ " +
                                    _vm._s(
                                      _vm.paymentsSum ? _vm.paymentsSum : "0"
                                    )
                                )
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.togglePayments
                          ? _vm._l(
                              _vm.selectedTotal.charges.filter(function(el) {
                                return el.payment_type_id === 1
                              }),
                              function(transaction, index) {
                                return _c("div", { key: transaction.id }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "section-content d-flex pb-2"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "payment-type" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                transaction.payment_type.name
                                              ) +
                                              "\n                "
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "btn btn-link p-0 tippy-popup m-0",
                                              on: {
                                                mouseover: function($event) {
                                                  _vm.$set(
                                                    _vm.showTooltipPayments,
                                                    index,
                                                    true
                                                  )
                                                },
                                                mouseout: function($event) {
                                                  _vm.$set(
                                                    _vm.showTooltipPayments,
                                                    index,
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-info-circle totals-icon"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.showTooltipPayments[index]
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "popover popover-transaction tippy-info-popover"
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(transaction.date)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          transaction.payment_method_id ===
                                                          4
                                                            ? "(**** " +
                                                              transaction.card
                                                                .last4 +
                                                              ")"
                                                            : ""
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          transaction
                                                            .payment_method.name
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(transaction.note)
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "\n                $ " +
                                            _vm._s(transaction.amount) +
                                            "\n              "
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              }
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "section-content d-flex" }, [
                          _c(
                            "span",
                            {
                              staticClass: "pointer",
                              on: {
                                click: function($event) {
                                  _vm.toggleRefunds = !_vm.toggleRefunds
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa text-secondary",
                                class: _vm.toggleRefunds
                                  ? "fa fa-caret-down"
                                  : "fa fa-caret-right",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v(" "),
                              _c("strong", [
                                _vm._v("\n              Refunds\n            ")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c("strong", [
                              _vm._v(
                                "$ " +
                                  _vm._s(_vm.refundsSum ? _vm.refundsSum : "0")
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.toggleRefunds
                          ? _vm._l(
                              _vm.selectedTotal.charges.filter(function(el) {
                                return (
                                  el.payment_type_id === 2 ||
                                  el.payment_type_id === 4
                                )
                              }),
                              function(transaction, index) {
                                return _c("div", { key: index }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "section-content d-flex pb-2"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "payment-type" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                transaction.payment_type.name
                                              ) +
                                              "\n                "
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "btn btn-link p-0 tippy-popup m-0",
                                              on: {
                                                mouseover: function($event) {
                                                  _vm.$set(
                                                    _vm.showTooltipRefunds,
                                                    index,
                                                    true
                                                  )
                                                },
                                                mouseout: function($event) {
                                                  _vm.$set(
                                                    _vm.showTooltipRefunds,
                                                    index,
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-info-circle"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.showTooltipRefunds[index]
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "popover popover-transaction tippy-info-popover"
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(transaction.date)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          transaction.payment_method_id ===
                                                          4
                                                            ? "(**** " +
                                                              transaction.card
                                                                .last4 +
                                                              ")"
                                                            : ""
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          transaction
                                                            .payment_method.name
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(transaction.note)
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "\n                $ " +
                                            _vm._s(transaction.amount) +
                                            "\n              "
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              }
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "pricing-section d-flex" }, [
                          _c("span", [
                            _c("strong", [
                              _vm._v(
                                "\n              Total price\n            "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("strong", [
                              _vm._v(
                                "\n              $ " +
                                  _vm._s(_vm.selectedTotal.total_price) +
                                  "\n            "
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pricing-section d-flex" }, [
                          _c("small", { staticClass: "text-secondary" }, [
                            _vm._v("\n            Total fee\n          ")
                          ]),
                          _vm._v(" "),
                          _c("small", { staticClass: "text-secondary" }, [
                            _vm._v(
                              "\n            $ " +
                                _vm._s(_vm.selectedTotal.total_fee) +
                                "\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pricing-section d-flex" }, [
                          _c("span", [
                            _vm._v("\n            Balance due\n          ")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "balance-due" }, [
                            _vm._v(
                              "\n            $ " +
                                _vm._s(_vm.selectedTotal.remaining_price) +
                                "\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "section-name mt-2" }, [
                          _c("h2", { staticClass: "totals-side-modal-h2" }, [
                            _vm._v("mover details")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "section-heading" }, [
                          _c("span", [_vm._v("Crew")]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.openWagesAndExtrasModal($event)
                                }
                              }
                            },
                            [
                              _c("a", { attrs: { href: "#" } }, [
                                _vm._v(
                                  "\n              Edit wages and extras\n            "
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        !_vm.loadingPayouts
                          ? _c(
                              "div",
                              { staticClass: "pricing-section mb-4" },
                              _vm._l(_vm.selectedTotal.payouts, function(
                                payout
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: payout.user_id,
                                    staticClass: "row w-full"
                                  },
                                  [
                                    _c("div", { staticClass: "col-4" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(payout.mover) +
                                          "\n              "
                                      ),
                                      payout.foreman
                                        ? _c(
                                            "span",
                                            { class: "foreman-status-blue" },
                                            [_vm._v("F")]
                                          )
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-6" }, [
                                      _vm._v(
                                        "\n              $ " +
                                          _vm._s(payout.total_wage) +
                                          " + $ " +
                                          _vm._s(payout.extras) +
                                          " extras + $ " +
                                          _vm._s(payout.card_tips) +
                                          " tips\n            "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-2" }, [
                                      _c("strong", [
                                        _vm._v(
                                          "\n                $ " +
                                            _vm._s(payout.total_payout) +
                                            "\n              "
                                        )
                                      ])
                                    ])
                                  ]
                                )
                              })
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedTotal.agreements &&
                        _vm.selectedTotal.agreements.length
                          ? [
                              _c("div", { staticClass: "section-name mt-2" }, [
                                _c(
                                  "h2",
                                  { staticClass: "totals-side-modal-h2" },
                                  [_vm._v("contracts")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "pricing-section mb-4" },
                                _vm._l(_vm.selectedTotal.agreements, function(
                                  agreement
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: agreement.id,
                                      staticClass: "row w-full"
                                    },
                                    [
                                      _c("div", { staticClass: "col" }, [
                                        _c("i", {
                                          staticClass: "fa fa-file mt-2"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: agreement.url,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  agreement.url.substring(
                                                    agreement.url.lastIndexOf(
                                                      "/"
                                                    ) + 1
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                })
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.wagesAndExtrasModal
        ? _c("MoverWagesModal", {
            attrs: {
              id: _vm.selectedTotal.job_id,
              payouts: _vm.selectedTotal.payouts
            },
            on: {
              close: function($event) {
                _vm.wagesAndExtrasModal = false
              },
              updated: _vm.getPayouts
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.saveFiltersModal
        ? _c("SaveFiltersModal", {
            attrs: { filters: _vm.filters, route: _vm.$route.path },
            on: {
              close: function($event) {
                _vm.saveFiltersModal = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-3" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-3 text-center" }, [
        _c("span", { staticClass: "total-table-title" }, [
          _vm._v("Company Profit")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3 text-center" }, [
        _c("span", { staticClass: "total-table-title" }, [
          _vm._v("Cluster Profit")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3 text-center" }, [
        _c("span", { staticClass: "total-table-title" }, [
          _vm._v("Balance due")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-1" }, [_c("h1", [_vm._v("Totals")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-802fe2a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-802fe2a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/Totals.vue
// module id = null
// module chunks = 